import React, { ReactElement, ReactNode } from "react";
import { useStyles } from "./FormLayoutHeader.styles";
import { Box, Typography } from "@mui/material";

interface MainLayoutProps {
    children?: ReactNode;
    label?: ReactNode | string;
    title?: ReactNode | string;
    align?: "left" | "center" | "right";
}

const FormLayoutHeader = ({ children, label, title, align = "left" }: MainLayoutProps): ReactElement => {
    const styles = useStyles();

    return (
        <div className={styles.formHeader}>
            <Box sx={{ height: { xs: "20px", md: "56px" } }}></Box>
            {label && (
                <Typography align={align} variant="subtitle1">
                    {label}
                </Typography>
            )}
            {title && (
                <Typography align={align} variant="h2">
                    {title}
                </Typography>
            )}
            <Box sx={{ height: { xs: "32px", md: "45px" } }}></Box>
            {children}
        </div>
    );
};
export default FormLayoutHeader;
